<template>
  <div class="my-textarea">
    <textarea ref="textarea" :style="{'height': height}" :maxlength="maxLength" v-model="value" :placeholder="placeholder" class="textarea" ></textarea>
  </div>
</template>

<script>
import calcTextareaHeight from '../../assets/js/calcTextareaHeight.js'
import { Toast } from 'mint-ui'
export default {
  name: 'aw-textarea',
  props: {
    // 用来辨别是哪个数据调用的
    textareaName: {
      required: true
    },
    // placeholder显示的内容
    placeholder: {
      default: '请填写'
    },
    // 最多字数
    maxLength: {
      default: 200
    }
  },
  data () {
    return {
      // textarea内容
      value: '',
      // 动态高度
      height: 0
    }
  },
  watch: {
    value () {
      if (this.$refs.textarea.value.length >= this.maxLength) {
        Toast(`最多可以填写${this.maxLength}字哦~`)
      }
      this.getHeight()
      this.$emit('changeTextarea', this.value, this.textareaName)
    }
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.height = calcTextareaHeight(this.$refs.textarea, 1, null).height
    }
  }
}
</script>

<style lang="stylus" scoped>
  .my-textarea
    margin-left : .2rem
    margin-right : .2rem
    .textarea
      padding: 0
      position: relative
      display: inline-block
      width: 100%
      height: 2rem
      line-height: .5rem
      text-align : justify
      font-size: .4rem
      resize: none
      color: #976e48
      border-radius: 0
      border: none
      border-bottom: 1px solid #f8bc77
      background-color: #fffcf5
</style>



// WEBPACK FOOTER //
// src/servey/compoents/MyTextarea.vue